import React from 'react';
import { Value } from './partials';
export var DefaultComponent = function DefaultComponent(_ref) {
  var value = _ref.value,
    _ref$inline = _ref.inline,
    inline = _ref$inline === void 0 ? false : _ref$inline;
  if (!value) return null;
  return React.createElement(Value, {
    inline: inline
  }, value);
};